import { Platform } from 'react-native';

export type PwaInstallPlatform = 'ios' | 'android' | 'desktop';

export function isPwaInstalled() {
  if (Platform.OS !== 'web' || typeof window === 'undefined') {
    return false;
  }

  const standaloneQuery = window.matchMedia?.('(display-mode: standalone)').matches ?? false;
  const iosStandalone = Boolean((window.navigator as Navigator & { standalone?: boolean }).standalone);
  return standaloneQuery || iosStandalone;
}

export function detectPwaInstallPlatform(): PwaInstallPlatform | null {
  if (Platform.OS !== 'web' || typeof navigator === 'undefined' || isPwaInstalled()) {
    return null;
  }

  const ua = navigator.userAgent;
  const isIOS =
    /iPad|iPhone|iPod/.test(ua) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

  if (isIOS) {
    return 'ios';
  }
  if (/Android/.test(ua)) {
    return 'android';
  }
  return 'desktop';
}
